import { render, staticRenderFns } from "./DatasetLink.vue?vue&type=template&id=1674e7c6"
import script from "./DatasetLink.vue?vue&type=script&setup=true&lang=ts"
export * from "./DatasetLink.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports